module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"eventOverview":"Seminarübersicht"},"en":{"eventOverview":"Event overview"}}')
  delete Component.options._Ctor
}
